import React, { useState } from "react";
import styled from "styled-components";

import ContentUnit from "./content-unit";
import { normalizeMedia } from "./utils/normalize-media";

const Root = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const StyledContent = styled(ContentUnit)`
  /* display: block; */
  display: inline-block;
  height: ${({ height, text }) => (text ? "auto" : `${height}px`)};
  width: ${({ width }) => width}px;
  max-width: 100%;
  margin: ${({ spacing }) => spacing / 2}px;
  object-fit: cover;
  -webkit-tap-highlight-color: transparent;
  align-self: ${({ anchor }) => {
    switch (anchor) {
      case "top":
        return "flex-start";
      case "bottom":
        return "flex-end";
      default:
        return anchor;
    }
  }};
`;

const Gallery = ({ slides, spacing = 32, height, aspectRatio }) => {
  // TODOS LOS HOOKS DEBEN IR PRIMERO (reglas de React Hooks)
  // Usar un valor seguro por defecto para evitar errores si slides es null/undefined
  const [playing, setPlaying] = useState(
    slides && Array.isArray(slides) ? Array(slides.length).fill(true) : []
  );

  // Guard clauses: validar datos críticos (DESPUÉS de los hooks)
  if (!slides || !Array.isArray(slides) || slides.length === 0) {
    if (process.env.NODE_ENV === "development") {
      console.warn(
        "[Gallery] No slides provided or slides array is empty. Skipping render."
      );
    }
    return null;
  }

  // Normalizar parámetros usando el helper
  // Usar el primer slide con imagen para obtener dimensiones si están disponibles
  const firstImageSlide = slides.find(
    (slide) => slide.image && (slide.image.fluid || slide.image.dimensions)
  );

  const normalized = normalizeMedia({
    aspectRatio,
    height,
    spacing,
    image: firstImageSlide?.image || null,
  });

  const { innerWidth: width, safeHeight, safeSpacing } = normalized;

  // Reporting y validaciones en desarrollo
  if (process.env.NODE_ENV === "development") {
    // Contar slides con imágenes sin dimensions
    const imageSlides = slides.filter(
      (slide) => slide.image && (slide.image.fluid || slide.image.url)
    );
    const slidesWithoutDimensions = imageSlides.filter(
      (slide) => !slide.image.dimensions || !slide.image.dimensions.width || !slide.image.dimensions.height
    );

    if (slidesWithoutDimensions.length > 0) {
      console.warn(
        `[Gallery] ⚠️ ${slidesWithoutDimensions.length} de ${imageSlides.length} slides con imágenes no tienen dimensions de Prismic.`,
        "Esto puede afectar la precisión del cálculo de aspect ratio.",
        "Para solucionarlo, asegúrate de que las imágenes en Prismic tengan dimensiones procesadas."
      );
    }

    // Warnings cuando falten parámetros editoriales
    if (aspectRatio === null || aspectRatio === undefined) {
      console.warn(
        "[Gallery] ⚠️ aspectRatio del slice es null/undefined.",
        "Usando fallback desde image.dimensions o valor por defecto (16/9).",
        "Recomendación: Configurar aspectRatio en Prismic para este slice."
      );
    }
    if (height === null || height === undefined) {
      console.warn(
        "[Gallery] ⚠️ height del slice es null/undefined.",
        "Usando altura por defecto de 100px.",
        "Recomendación: Configurar height en Prismic para este slice."
      );
    }
    if (spacing === null || spacing === undefined) {
      console.warn(
        "[Gallery] ⚠️ spacing del slice es null/undefined.",
        "Usando espaciado por defecto de 0px.",
        "Recomendación: Configurar spacing en Prismic para este slice."
      );
    }
  }
  
  return (
    <Root height={safeHeight}>
      {slides.map((slide, i) => (
        <StyledContent
          key={i}
          text={slide.type === "text"}
          anchor={slide.verticalAlign}
          {...slide}
          height={safeHeight}
          width={width}
          spacing={safeSpacing}
          breakpoint={(width + safeSpacing) * slides.length}
          playing={playing[i]}
          onPlayingChange={(newPlaying) =>
            setPlaying([
              ...playing.slice(0, i),
              newPlaying,
              ...playing.slice(i + 1),
            ])
          }
        />
      ))}
    </Root>
  );
};

Gallery.propTypes = {};

export default Gallery;
